export const APPLICATION_JSON = /application\/([a-z].+)?json/
export const TEXT_PLAIN = /text\/([a-z].+)?/
